module.exports = __webpack_public_path__ + "static/media/21ECLAC4.1238b43c.jpg";